import React, { useState, useEffect } from "react";
import hero1 from "../assets/images/home-photo1.jpg";
import hero2 from "../assets/images/home-photo2.jpg";
import hero3 from "../assets/images/home-photo3.jpg";
import hero4 from "../assets/images/home-photo4.jpg";

const images = [hero1, hero2, hero3, hero4]; // Add all images you want to rotate

export default function Hero() {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 5000); // Change image every 5 seconds
        return () => clearInterval(interval);
    }, []);

    return (
        <section id="hero" className="hero-section" style={{ position: "relative" }}>
            {/* Rotating background image */}
            <div
                className="hero-bg-image"
                style={{
                    backgroundImage: `url(${images[currentImage]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "100vh",
                    transition: "background-image 1s ease-in-out",
                }}
            ></div>

            {/* Overlay */}
            <div
                className="hero-overlay"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.4)", // semi-transparent overlay
                }}
            ></div>

            {/* Content */}
            <div
                className="container text-center hero-content"
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "#fff",
                }}
            >
                <h1 className="display-4 fw-bold animate-fade-up">
                    Anand Tech Plast Pvt Ltd
                </h1>
                <p className="lead animate-fade-up delay-1">
                    Delivering smile with our toys, proudly made in india.
                </p>
                <button
                    onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
                    className="hero-btn fw-bold mt-3 animate-fade-up delay-2"
                >
                    Learn More
                </button>

            </div>
        </section>
    );
}
